import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { IMG } from "../lib/data";

const CTASection = () => {
  const { t, isRTL } = useLanguage();
  const navigate = useNavigate();

  return (
    <section className="relative py-24 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${IMG.cityNight})` }}
      />
      <div className="absolute inset-0 bg-[#0A1223]/90" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight">
            {t.cta.heading}
          </h2>
          <p className="mt-5 text-base text-[#AAB6C6] leading-relaxed">{t.cta.sub}</p>
          <div className="mt-8 flex flex-wrap gap-4">
            <button
              onClick={() => navigate("/request-quotation")}
              data-testid="cta-rfq-btn"
              className="btn-gold inline-flex items-center gap-2 px-7 py-4 group"
            >
              {t.common.requestQuotation}
              <ArrowRight size={18} className={`transition-transform group-hover:translate-x-1 ${isRTL ? "rotate-180 group-hover:-translate-x-1" : ""}`} />
            </button>
            <button
              onClick={() => navigate("/contact")}
              className="inline-flex items-center gap-2 px-7 py-4 border border-white/20 text-white hover:bg-white/5 transition-colors"
            >
              {t.common.talkToEngineer}
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
